import primaryComponents, {
  BackButton,
} from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import { TransferArrowIcon } from "../../../../../assets/svgIcons";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import useValidation from "../CreateTransfer/useValidation";
import { useEditStockTransfer } from "./useEditStockTransfer";
import { useEffect } from "react";
import { RoutedModal } from "../../../../../components/common";
import StockTransferModal from "../Modal";
import { useSelector } from "react-redux";

const EditStockTransfer = () => {
  const {
    transferData,
    isLoading,
    isTransferUpdating,
    autoScrollRef,
    isFetchingNextPage,
    otherTransferInfo,
    setOtherTransferInfo,
    updateTransferProducts,
    setTransferData,
    missingProducts,
    setMissingProducts,
  } = useEditStockTransfer();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const validation = useValidation({
    transferData,
  });
  const { handleSubmit, setValue } = validation;

  useEffect(() => {
    setValue(
      "transfer_from_store_id",
      otherTransferInfo?.transfer_from_store_id,
    );
    setValue("transfer_to_store_id", otherTransferInfo?.transfer_to_store_id);
  }, [otherTransferInfo]);

  return (
    <>
      <secondaryComponents.MetaSetter
        title="Lumi Merchant | Inventory - Stock Transfer"
        description="Edit stock transfer"
      >
        <secondaryComponents.RequestLoaderTrigger>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.3 } }}
            exit={{ opacity: 0, transition: { duration: 0.5 } }}
            className={globalStyles.pageColumnGaps}
          >
            <div className={globalStyles.pageHeaders}>
              <div className="d-flex" style={{ alignItems: "center" }}>
                <BackButton />
                <h4 className="ml-3 mb-0">{"Transfer Stock"}</h4>
              </div>

              <primaryComponents.Button
                classNames={"btn btn--primary"}
                isLoading={isTransferUpdating}
                isDisabled={isTransferUpdating}
                loadingText={"Updating..."}
                onClick={handleSubmit(updateTransferProducts)}
              >
                <TransferArrowIcon />
                <span className="ml-2">Update Request Transfer</span>
              </primaryComponents.Button>
            </div>

            {/* content section */}
            <secondaryComponents.LoaderHelper isLoading={isLoading}>
              <secondaryComponents.StockTransferForm
                transferData={transferData}
                setTransferData={setTransferData}
                otherTransferInfo={otherTransferInfo}
                setOtherTransferInfo={setOtherTransferInfo}
                validation={validation}
                isFetchingNextPage={isFetchingNextPage}
                autoScrollRef={autoScrollRef}
                isEditMode={true}
              />
            </secondaryComponents.LoaderHelper>
            {/* table section */}
          </motion.div>
        </secondaryComponents.RequestLoaderTrigger>
      </secondaryComponents.MetaSetter>
      <RoutedModal
        isActive={missingProducts}
        closeModal={() => setMissingProducts(false)}
        width={500}
        showHeader={false}
        style={{
          height: "auto",
          borderRadius: "8px",
        }}
      >
        <StockTransferModal
          transferData={transferData}
          otherTransferInfo={otherTransferInfo}
          storeList={storeList}
          setMissingProducts={setMissingProducts}
          isTransfering={isTransferUpdating}
          replicateMissingProducts={updateTransferProducts}
          handleSubmit={handleSubmit}
        />
      </RoutedModal>
    </>
  );
};

export default EditStockTransfer;
